export default {
	data() {
		return {
			/**
			 * provinceList, cityList 省市区列表
			 * dlList 大类列表
			 * xlList 小类列表
			 * modelList 机型列表
			 * managementOptions 合作方列表
			 * referralTypeList 推荐类型
			 */
			provinceList: [],
			cityList: [],
			dlList: [],
			xlList: [],
			modelList: [],
			managementOptions: [],
			referralTypeList: [
				{
					referralTypeId: 1,
					referralTypeName: '门店导购',
				},
				{
					referralTypeId: 2,
					referralTypeName: '小区物业',
				},
				{
					referralTypeId: 3,
					referralTypeName: '普通用户',
				},
			]
		}
	},
	methods: {
		// 获取省份列表
		getTblProvince() {
			const url = `/autoapp-default-server-recovery/api/partnerManagementBond/findAllProvince`
			return this.HttpService.post(url).then(res => {
				if (res.statusCode === 200) {
					this.provinceList = res.data || []
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 根据省份获取城市列表
		getTblCity(provinceCode) {
			const url = `/autoapp-default-server-recovery/api/partnerManagementBond/findAllCity/${provinceCode}`
			return this.HttpService.post(url).then(res => {
				if (res.statusCode === 200) {
					this.cityList = res.data || []
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 获取大类
		getTblSplbDalei() {
			const url = '/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=3'
			this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					this.dlList = res.data
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 获取小类
		getSpXiaolei (spid) {
			if (!spid) {
				this.xlList = []
				return
			}
			const url = `/autoapp-default-server-recovery/api/tbl-splb-xiaolei/getTblSplbXiaolei?flag=1&spid=${spid}`
			return this.HttpService.get(url).then(res => {
				// console.log('小类', res)
				if (res.statusCode === 200) {
					const resData = res.data || []
					resData.forEach(item => {
						item.xhid = item.xhno
					})
					this.xlList = resData
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 获取合作方下拉数据
		getManagementOptions() {
			const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/page'
			const params = {
				pageNum: 1,
				pageSize: 999,
				partnerName: '',
				partnershipType: 2,
			}
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					this.managementOptions = res.data.records
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 获取机型
		getSpModel (spid, xlid) {
			if (!spid && !xlid) {
					this.modelList = []
					return
				}
			let params = {
				flag: 1,
				spid,
				xlid,
			}
			const url = `/autoapp-default-server-recovery/api/tbl-splb-jixin/getTblSplbJixin?flag=1&id=&spid=${spid}&xlid=${xlid}`
			this.HttpService.get(url, params).then(res => {
				// console.log('型号', res)
				if (res.statusCode === 200) {
					const resData = res.data || []
					resData.forEach(item => {
						item.xhid = item.xhno
					})
					this.modelList = resData
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
	},
}



// WEBPACK FOOTER //
// ./src/views/commissionManage/mixins/selectOptions.js